import PBLogo from '@/assets/branding/pelicanbayou/pelicanbayoulogo.png';

export default {
  name: 'Pelican Bayou',
  isSAML: true,
  allowPersonalCourses: false,
  logo: PBLogo,
  colors: {
    // Brand colors
    brand_primary: '#0E74B7',
    brand_primary_hover: '#0C639C', // −10 L, −8 S
    brand_primary_highlight: '#6AB7EB', // +23 L, +7 S
    brand_primary_mid: '#1B82C5', // +8 L,  +2 S
    brand_primary_dark: '#06355C', // −25 L, −3 S
    brand_secondary: '#0B5A8A', // hue +4°, −15 L, −13 S
  },
};
